<div class="grid grid-cols-2 mt-48">
    <button style="border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%; width: 70%;"
        matTooltip="In this section you will find the different categories of Key Performance Indicators and the results of each of them at Project level."
        matTooltipClass="text-xl"
        class="mt-4 px-12 py-4 text-4xl font-light cursor-pointer bg-evaluationfr hover:bg-evaluationhover text-blue-100 hover:text-blue-400 place-self-center"
        (click)="goToKpis()">
        <div class="text-center justify-center">
            <i class="fas fa-chart-bar text-3xl"></i> <br> KPIs
        </div>
    </button>
    <button style="border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%; width: 70%;"
        matTooltip="In this section you will find the different FUSILLI impacts including their definition, the KPIs related to each impact and result."
        matTooltipClass="text-xl"
        class="mt-4 px-12 py-4 text-4xl font-light cursor-pointer bg-headerfr hover:bg-buttonhover text-yellow-200 hover:text-colortext place-self-center"
        (click)="goToFusilliImpacts()">
        <div class="text-center justify-center">
            <i class="fas fa-chart-pie text-3xl"></i> <br> FUSILLI Impacts
        </div>
    </button>
</div>